// package: tenantmanager
// file: tenant-manager.proto

var tenant_manager_pb = require("./tenant-manager_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var TenantManager = (function () {
  function TenantManager() {}
  TenantManager.serviceName = "tenantmanager.TenantManager";
  return TenantManager;
}());

TenantManager.GetMyTenants = {
  methodName: "GetMyTenants",
  service: TenantManager,
  requestStream: false,
  responseStream: false,
  requestType: tenant_manager_pb.GetMyTenantsReq,
  responseType: tenant_manager_pb.GetMyTenantsReply
};

TenantManager.GetMyTenant = {
  methodName: "GetMyTenant",
  service: TenantManager,
  requestStream: false,
  responseStream: false,
  requestType: tenant_manager_pb.GetMyTenantReq,
  responseType: tenant_manager_pb.GetMyTenantReply
};

TenantManager.GetSeatUsage = {
  methodName: "GetSeatUsage",
  service: TenantManager,
  requestStream: false,
  responseStream: false,
  requestType: tenant_manager_pb.GetSeatUsageReq,
  responseType: tenant_manager_pb.GetSeatUsageReply
};

TenantManager.SetRoomSeatLimits = {
  methodName: "SetRoomSeatLimits",
  service: TenantManager,
  requestStream: false,
  responseStream: false,
  requestType: tenant_manager_pb.SetRoomSeatLimitsReq,
  responseType: tenant_manager_pb.SetRoomSeatLimitsReply
};

TenantManager.ReleaseClosedRoomAccounts = {
  methodName: "ReleaseClosedRoomAccounts",
  service: TenantManager,
  requestStream: false,
  responseStream: false,
  requestType: tenant_manager_pb.ReleaseClosedRoomAccountsReq,
  responseType: tenant_manager_pb.ReleaseClosedRoomAccountsReply
};

TenantManager.ListTenantDedicatedEnvs = {
  methodName: "ListTenantDedicatedEnvs",
  service: TenantManager,
  requestStream: false,
  responseStream: false,
  requestType: tenant_manager_pb.ListTenantDedicatedEnvsReq,
  responseType: tenant_manager_pb.ListTenantDedicatedEnvsReply
};

TenantManager.SetRoomDedicatedEnv = {
  methodName: "SetRoomDedicatedEnv",
  service: TenantManager,
  requestStream: false,
  responseStream: false,
  requestType: tenant_manager_pb.SetRoomDedicatedEnvReq,
  responseType: tenant_manager_pb.SetRoomDedicatedEnvReply
};

TenantManager.UpdateBranding = {
  methodName: "UpdateBranding",
  service: TenantManager,
  requestStream: false,
  responseStream: false,
  requestType: tenant_manager_pb.UpdateBrandingReq,
  responseType: tenant_manager_pb.UpdateBrandingReply
};

TenantManager.UploadBrandingAsset = {
  methodName: "UploadBrandingAsset",
  service: TenantManager,
  requestStream: false,
  responseStream: false,
  requestType: tenant_manager_pb.UploadBrandingAssetReq,
  responseType: tenant_manager_pb.UploadBrandingAssetReply
};

exports.TenantManager = TenantManager;

function TenantManagerClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

TenantManagerClient.prototype.getMyTenants = function getMyTenants(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TenantManager.GetMyTenants, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TenantManagerClient.prototype.getMyTenant = function getMyTenant(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TenantManager.GetMyTenant, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TenantManagerClient.prototype.getSeatUsage = function getSeatUsage(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TenantManager.GetSeatUsage, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TenantManagerClient.prototype.setRoomSeatLimits = function setRoomSeatLimits(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TenantManager.SetRoomSeatLimits, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TenantManagerClient.prototype.releaseClosedRoomAccounts = function releaseClosedRoomAccounts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TenantManager.ReleaseClosedRoomAccounts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TenantManagerClient.prototype.listTenantDedicatedEnvs = function listTenantDedicatedEnvs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TenantManager.ListTenantDedicatedEnvs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TenantManagerClient.prototype.setRoomDedicatedEnv = function setRoomDedicatedEnv(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TenantManager.SetRoomDedicatedEnv, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TenantManagerClient.prototype.updateBranding = function updateBranding(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TenantManager.UpdateBranding, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TenantManagerClient.prototype.uploadBrandingAsset = function uploadBrandingAsset(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TenantManager.UploadBrandingAsset, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.TenantManagerClient = TenantManagerClient;

